var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import template from 'text!./templates/icon.html';
import './icon.scss';

export default (function () {

    function link(scope) {

        function setIcon() {
            var commonClasses = ['gw-icon'];
            if (scope.flavour) commonClasses.push('gw-icon--' + scope.flavour);
            var isFontAwesome = scope.name.startsWith('fa-');
            scope.icon = {};
            if (!isFontAwesome) {
                scope.icon.classList = commonClasses.concat(['gw-icon--icon-font', 'gw-icon--' + scope.name]).join(' ');
            } else {
                scope.icon.classList = commonClasses.concat(['gw-icon--fa', 'fa', scope.name]).join(' ');
            }
        }

        setIcon();
        scope.$watchGroup(['name', 'flavour'], function (_ref, _ref2) {
            var _ref4 = _slicedToArray(_ref, 2),
                newName = _ref4[0],
                newFlavour = _ref4[1];

            var _ref3 = _slicedToArray(_ref2, 2),
                oldName = _ref3[0],
                oldFlavour = _ref3[1];

            if (newName && newName !== oldName || newFlavour !== oldFlavour) setIcon();
        });
    }

    return {
        template: template,
        link: link,
        replace: true,
        scope: {
            name: '@',
            flavour: '@'
        },
        restrict: 'E'
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/icon/directives/icon/IconDirective.js
// module id = 1962
// module chunks = 0